<ul class="list-group list-group-flush">
    <li *ngFor="let item of items" class="list-group-item p-4">
        <div class="d-flex flex-row justify-content-start align-items-center">
            <fa-icon [icon]="['fas', 'chevron-right']" class="me-2"></fa-icon>
            <span class="ms-4 span-item-text" [innerHTML]="item.text"></span>
        </div>
    </li>
</ul>
